import "./header.css";

import React from "react";

import logo from "../../../../assets/images/logo.png"

const Header = () => {
    return (
        <header className="app-header">
            <div className="app-header-logo">
                <a target="_blank" rel="noreferrer" href="//umbrellait.com">
                    <img src={logo} alt="logo.png"/>
                </a>
            </div>
        </header>
    )
}

export default Header